"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _DomEvents = require("../utils/DomEvents");

var hasPingedNewRelic = false;

var reportDeprecatedMethod = function reportDeprecatedMethod(componentName, methodName) {
  if (process.env.NODE_ENV !== 'production') {
    _devLogger.default.warn({
      message: componentName + ": Calling `" + methodName + "` on a ref to an input component is deprecated. " + "Use `inputRef` to get a direct reference to the <input> or <textarea> instead.",
      key: "ShareInput-" + methodName
    });
  }

  if (window.newrelic && !hasPingedNewRelic) {
    window.newrelic.addPageAction('share-hoc-method', {
      hoc: 'ShareInput',
      componentName: componentName,
      methodName: methodName
    });
    hasPingedNewRelic = true;
  }
};

var getInputRef = function getInputRef(component) {
  return component.props.inputRef || component._defaultInputRef;
};

function _default(Component) {
  var ShareInputDecorator = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2.default)(ShareInputDecorator, _React$Component);

    function ShareInputDecorator() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, ShareInputDecorator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShareInputDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.focus = function () {
        if (_this._ref && typeof _this._ref.focus === 'function') {
          _this._ref.focus();

          return;
        }

        reportDeprecatedMethod(_this.constructor.CoreComponent.displayName, 'focus');
        var inputRef = _this.props.inputRef || _this._defaultInputRef;

        if (inputRef.current && typeof inputRef.current.focus === 'function') {
          inputRef.current.focus();
        }
      };

      _this.select = function () {
        if (_this._ref && typeof _this._ref.select === 'function') {
          _this._ref.select();

          return;
        }

        reportDeprecatedMethod(_this.constructor.CoreComponent.displayName, 'select');
        var inputRef = _this.props.inputRef || _this._defaultInputRef;

        if (inputRef.current && typeof inputRef.current.select === 'function') {
          inputRef.current.select();
        }
      };

      _this.refCallback = function (ref) {
        if ((0, _utils.isFunctionalComponent)(Component)) return;
        _this._ref = ref;
        if (ref) (0, _utils.copyMethods)(ref, (0, _assertThisInitialized2.default)(_this));
      };

      _this.handleCompositionStart = function (evt) {
        var onCompositionStart = _this.props.onCompositionStart; // Prevent keyup/keydown while IME composition is in progress

        var inputEl = getInputRef((0, _assertThisInitialized2.default)(_this)).current;
        inputEl.addEventListener('keyup', _DomEvents.stopPropagationHandler);
        inputEl.addEventListener('keydown', _DomEvents.stopPropagationHandler);
        if (onCompositionStart) onCompositionStart(evt);
      };

      _this.handleCompositionEnd = function (evt) {
        var onCompositionEnd = _this.props.onCompositionEnd; // Resume allowing keyup/keydown events

        var inputEl = getInputRef((0, _assertThisInitialized2.default)(_this)).current;
        inputEl.removeEventListener('keyup', _DomEvents.stopPropagationHandler);
        inputEl.removeEventListener('keydown', _DomEvents.stopPropagationHandler);
        if (onCompositionEnd) onCompositionEnd(evt);
      };

      _this._defaultInputRef = (0, _react.createRef)();
      return _this;
    }

    (0, _createClass2.default)(ShareInputDecorator, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, Object.assign({}, this.props, {
          onCompositionStart: this.handleCompositionStart,
          onCompositionEnd: this.handleCompositionEnd,
          inputRef: getInputRef(this),
          ref: this.refCallback
        }));
      }
    }]);
    return ShareInputDecorator;
  }(_react.default.Component);

  var componentName = (0, _getComponentName.default)(Component);
  ShareInputDecorator.displayName = "ShareInput(" + componentName + ")";
  ShareInputDecorator.propTypes = Object.assign({}, Component.propTypes, {
    inputRef: _refObject.default
  });
  ShareInputDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareInputDecorator, Component);
  return ShareInputDecorator;
}

module.exports = exports.default;